import { ChakraVStack as VStack, ChakraHeading as Heading, ChakraText as Text } from "@airhelp/react-ui-components";
import type { SectionHeaderProps } from "./SectionHeader.d";

export const SectionHeader = ({ preheader, header, id, dataTestId, ...props }: SectionHeaderProps) => (
  <VStack {...props}>
    {preheader && (
      <Text fontSize="xs" color="primary.500" textTransform="uppercase" fontWeight="bold" letterSpacing="1.5px">
        {preheader}
      </Text>
    )}
    <Heading variant="h2" as="h2" size="xl" id={id} data-testid={dataTestId}>
      {header}
    </Heading>
  </VStack>
);
